
import { defineComponent } from "vue";

export default defineComponent({
  name: "BotaoExcluir",
  props: {
    btnText: {
      type: String,
      required: false,
      default: "",
    },
  },
});
